import {Closest} from '@acng/frontend-bounty/dom/attribute.js';
import {guard} from '@acng/frontend-rubicon';

import {IMAGE_FORMAT as attributeName} from '../attribute/image-format.js';
import {IMAGE_FORMAT} from '../model/image.js';

const closestFormat = Closest(attributeName);

/**
 * @param {Element} element
 *
 * @returns {ImageFormat | null}
 */
export const getClosestImageFormat = (element) => {
  const format = closestFormat(element);
  ASSERT: guard(format, IMAGE_FORMAT);

  return format;
};
